@if (contactUsData; as data) {
  <strong>{{ data.directHireIntro }} </strong>
  <boels-generic-link
    [isExternal]="true"
    tabindex="0"
    [url]="'tel:' + data.directHirePhoneNumber | phoneFilter"
  >
    {{ data.directHirePhoneNumber }} {{ data.directHirePhoneSuffix }}
  </boels-generic-link>
}
